import React from 'react';
import CancelBtn from '../Buttons/CancelBtn';
import ConfirmBtn from '../Buttons/ConfirmBtn';

function ActionButtons({ cancel, confirm, fixed }) {
	return (
		<div className={`actionBtnRow  ${fixed ? 'actionBtnRow--fixed' : ''}`}>
			{cancel ? <CancelBtn infos={cancel} /> : ''}
			{confirm ? <ConfirmBtn infos={confirm} /> : ''}
		</div>
	);
}

export default ActionButtons;
